import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import type { Initiative } from '../../../../../api/initiative-client/initiative-client.type';
import { Table } from '../../../../../components/table/table';
import { useSelectedInitiativeStatuses } from '../../../../../store/process-analysis-store/process-analysis-store.hooks';
import { PAGE_SIZE, START_PAGE } from './table.constants';
import { customSort, getTableColumns } from './table.helpers';
import { useInitiativeOverviewTableData } from './table.hooks';
import type { Row } from './table.type';

type Props = {
  initiatives: Initiative[] | undefined;
};

export const InitiativeOverviewTable = ({ initiatives }: Props) => {
  const { t } = useTranslation();
  const selectedInitiativeStatuses = useSelectedInitiativeStatuses();
  const [currentPage, setCurrentPage] = useState(START_PAGE);

  const data = useInitiativeOverviewTableData(initiatives, selectedInitiativeStatuses);

  const columns = useMemo(() => getTableColumns(t), [t]);

  return (
    <Table<Row>
      data={data}
      columns={columns}
      getRowId={(row: Row) => row.id}
      defaultSortedBy="name"
      stickyHeader
      customSort={customSort}
      pageSize={PAGE_SIZE}
      currentPage={currentPage}
      totalItems={data.length}
      onPageChange={setCurrentPage}
    />
  );
};
